import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { DEFAULT_HELP_TAB, STANDARD_HELP_TABS } from './standardTabs';

/**
 * Shared Help & Documentation shell for RCM Platform services.
 * Pass tab renderers keyed by tab id; defaults to the standard 9-tab layout.
 */
const ServiceHelpPage = ({
  title = 'Help & Documentation',
  subtitle,
  tabs = STANDARD_HELP_TABS,
  defaultTab = DEFAULT_HELP_TAB,
  renderers = {},
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const renderContent = () => {
    const renderer = renderers[activeTab];
    if (renderer) return renderer();
    const fallback = renderers[defaultTab] || renderers['getting-started'];
    return fallback ? fallback() : null;
  };

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-sm border">
        <div className="flex items-center space-x-4">
          <div className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg">
            <HelpCircle className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {subtitle ? <p className="text-gray-600">{subtitle}</p> : null}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border">
        <div className="border-b border-gray-200 overflow-x-auto">
          <nav className="flex space-x-6 px-6 min-w-max">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-4 h-4 mr-2" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        <div className="p-6">{renderContent()}</div>
      </div>
    </div>
  );
};

export default ServiceHelpPage;
